import { Compass, TrendingUp, HeartPulse } from "lucide-react";

const ITEMS = [
  {
    icon: Compass,
    title: "Visión",
    text: "Todos alineados sobre hacia dónde va la empresa y cómo van a llegar.",
  },
  {
    icon: TrendingUp,
    title: "Tracción",
    text: "Disciplina, foco y accountability para ejecutar lo importante cada trimestre.",
  },
  {
    icon: HeartPulse,
    title: "Saludable",
    text: "Un equipo de liderazgo más abierto, cohesionado y funcional.",
  },
];

export default function WhatEOSAchieves() {
  return (
    <section id="que-es-eos" data-testid="what-eos-section" className="section-padding bg-white">
      <div className="container-eos">
        <div className="max-w-3xl reveal">
          <span className="eyebrow">¿Qué es EOS?</span>
          <h2 className="mt-3 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-navy-800 leading-tight">
            Un sistema simple, práctico y comprobado para empresas que quieren <span className="text-[#F26522]">escalar sin perder el control</span>.
          </h2>
          <p className="mt-5 text-lg text-slate-600">
            Adoptada por miles de empresas en todo el mundo, ayuda a tu equipo de liderazgo a lograr <strong>tres cosas fundamentales:</strong>
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {ITEMS.map((it, idx) => (
            <article
              key={idx}
              data-testid={`eos-achieve-${it.title.toLowerCase()}`}
              className="reveal relative rounded-2xl border border-slate-200 bg-white p-8 transition-all duration-300 hover:border-[#F26522]/40 hover:shadow-xl hover:-translate-y-1 overflow-hidden"
              style={{ transitionDelay: `${idx * 90}ms` }}
            >
              {/* Orange top accent bar */}
              <div className="absolute top-0 inset-x-0 h-1 bg-gradient-to-r from-[#F26522] to-[#F26522]/40" />
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-lg bg-navy-800 flex items-center justify-center shadow-md shadow-navy-800/10">
                  <it.icon className="w-5 h-5 text-white" strokeWidth={1.7} />
                </div>
                <span className="text-xs font-bold tracking-[0.2em] uppercase text-[#F26522]">
                  0{idx + 1} / 03
                </span>
              </div>
              <h3 className="mt-6 font-display font-extrabold text-2xl text-navy-800">{it.title}</h3>
              <p className="mt-3 text-slate-600 leading-relaxed">{it.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
